// Engine status as plain words, matching the PDF report (backend pdf_engine).
export function capaStatusLabel(meta = {}) {
  if (meta.capa_enabled) return 'Available';
  if (meta.capa_reason === 'capa_disabled_by_configuration') return 'Disabled';
  return 'Not available';
}

export function ghidraStatusLabel(meta = {}) {
  return meta.ghidra_available ? 'Available' : 'Not available';
}
